import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=1b98dfc6&"
import script from "./ListView.vue?vue&type=script&lang=ts&"
export * from "./ListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports